module.exports = __webpack_public_path__ + "img/blank_profile.778533c8.svg";